import { CHANNELS } from '@/models/dashboards/channels.enum';
import { useMetaAdsAccountDetails } from '@/app/dashboards/composables/useMetaAdsAccountDetails';
import { useTikTokAdsAccountDetails } from '@/app/dashboards/composables/useTikTokAdsAccountDetails';
import { toValue } from 'vue';

const CONTROLLER_FACTORIES = {
  [CHANNELS.META_ADS.value]: useMetaAdsAccountDetails,
  [CHANNELS.TIKTOK_ADS.value]: useTikTokAdsAccountDetails,
};

/**
 * @param {import('vue').MaybeRefOrGetter<keyof typeof CONTROLLER_FACTORIES>} channel
 * @returns {ReturnType<(typeof CONTROLLER_FACTORIES)[keyof typeof CONTROLLER_FACTORIES]> | null}
 */
export function getAdsPlatformController(channel) {
  const composable = CONTROLLER_FACTORIES[toValue(channel)];
  return composable ? composable() : null;
}
